import { render } from "./footerSection.vue?vue&type=template&id=442e4bc4&scoped=true"
import script from "./footerSection.vue?vue&type=script&lang=js"
export * from "./footerSection.vue?vue&type=script&lang=js"

import "./footerSection.vue?vue&type=style&index=0&id=442e4bc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-442e4bc4"]])

export default __exports__